<template>
    <div class="modal fade" id="createTaskModal" role="dialog" aria-labelledby="updateUsergroupModalLabel" aria-hidden="true">
        <div class="modal-dialog modal-lg" role="document">
            <div class="modal-content">
                <div class="modal-header mt-3 mb-0">
                    <h5 class="modal-title" id="updateUsergroupModalLabel">{{$t('buttons.usergroupCreate.btnText')}}</h5>
                    <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                        <span aria-hidden="true">&times;</span>
                    </button>
                </div>
                <div class="modal-body">
                    <role-edit-card v-model="model"
                                            v-if="showEditor"
                                            :create="true"
                                            @save="onSave"
                                            @cancel="onCancel">
                    </role-edit-card>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import { Role } from '../../../models/models';
    import RoleEditCard from './AspNetRoleEditCard';

    export default {
        components: {
            RoleEditCard
        },
        props: {
            show: {
                type: Boolean,
                default: false
            },
        },
        data() {
            return {
                showEditor: false,
                model: new Role(),
            };
        },
        methods: {
            onClose() {
                this.$emit('onClose', { ...this.model });
                this.model = new Role();
                this.$validator.reset();
            },
            hide() {
                $(this.$el).modal('hide');
            },
            onSave(model) {
                this.$emit('onCreate', model);
                this.onClose();
            },
            onCancel() {
                this.onClose();
            }
        },
        mounted() {
            $(this.$el).on('hidden.bs.modal', this.onClose);
        },
        beforeDestroy() {
            $(this.$el).off('hidden.bs.modal');
        },
        watch: {
            show: function (val) {
                if (val) {
                    this.model = new Role();
                    this.showEditor = true;
                    $(this.$el).modal('show');
                } else {
                    $(this.$el).modal('hide');
                }
            }
        }
    };
</script>

<style lang="scss" scoped>
    .bmd-form-group {
        padding-top: 0px !important;
    }
</style>
